export default __webpack_public_path__ + "afb3622f9edb1201f9458bf42d3130f4.png";